import { createSelector } from 'reselect';
import _ from 'lodash';
import moment from 'moment';

const entries = state => state.data.entries;
const tagDateMap = state => state.data.tagDateMap;
const filterTags = state => state.scene.main.filterTags;
const searchText = state => state.scene.main.searchText;
const readFilter = state => state.scene.main.readFilter;
const entriesSelected = state => state.scene.main.entriesSelected;
const entryId = (state, props) => props.entry.id;
const sortedByTags = state => state.scene.main.sortedByTags;
const tagsUpdated = state => state.scene.main.tagsUpdated;


const entryHasTags = (e, tags) => {
  if (!e.tags) return false;
  for (let t of tags) {
    if (e.tags.indexOf(t) < 0) return false;
  }
  return true;
}

const entryShouldShow = (e, tags, readFilter) => {
  const showRead = readFilter === 'read';
  if (e.isRead !== showRead && readFilter !== '') return false;
  if (!tags || tags.length <= 0) return true;
  return entryHasTags(e, tags);
}

const entryMatchesSearch = (e, searchText) => {
  const text = _.toLower(searchText)
  if (_.toLower(e.title).includes(text)) return true
  for (let t of e.tags) {
    let tagName = _.toLower(t)
    if (tagName.includes(text)) return true;
  }
  return false;
}
 
export const getVisibleEntries = createSelector(
  [entries, filterTags, readFilter, searchText],
  (entries, tags, readFilter, searchText) => {
    if (searchText.length > 0) {
      return _.filter(entries, (e) => { return entryMatchesSearch(e, searchText) })
    }
    return _.filter(entries, (e) => { return entryShouldShow(e, tags, readFilter) });
  }
)

export const isEntrySelected = createSelector(
  [entriesSelected, entryId],
  (entriesSelected, entryId) => {
    const entry = _.find(entriesSelected, (id) => id === entryId );
    return entry ? true : false;
  }
)

const getTagGroupings = (entries, tagDateMap) => {
  const tagGroups = _.reduce(entries, (tagMap, e) => {
    let header = e.tags && e.tags.length > 0 ?
        e.tags.sort().join(' + ') : 'Other';
    let entryGroup = tagMap[header];
    tagMap[header] = entryGroup ? [ ...entryGroup, e] : [e];
    return tagMap;
  }, {});
  // Sort by tag header
  const orderedTagGroups = {};
  const orderedHeaders = _.sortBy(_.keys(tagGroups), [(header) => {
    return (tagDateMap[header] && -1*tagDateMap[header].seconds) || null
  }, (header) => {
    return _.lowerCase(header)
  }]);
  orderedHeaders.forEach((header) => {
    let newHeader = header
    if (tagDateMap[header]) newHeader += (' | ' + moment.unix(tagDateMap[header].seconds).format('MMM DD'))
    orderedTagGroups[newHeader] = tagGroups[header];
  })
  return orderedTagGroups;
}

// const isLastMostRecent = (e) => {
//   return moment(e.dateAdded).isBefore(moment().subtract(1, 'minute'));
// }
//
const isRecent = (timestamp) => {
  return moment().subtract(1, 'minute').isBefore(moment.unix(timestamp.seconds));
}

const getDateString = timestamp => {
  const date = moment.unix(timestamp.seconds);
  if (date.isBefore(moment(), 'year')) {
    return date.format('MMM DD, YYYY');
  } else if (date.isBefore(moment().subtract(7, 'days'))) {
    return date.format('MMM DD');
  } else if (date.isBefore(moment().subtract(1, 'days'))) {
    return date.format('dddd');
  }
  return date.fromNow();
};

const getDateGroupings = (entries, sortDate) => {
  return _.reduce(entries, (dateMap, e) => {
    const timestamp = e[sortDate];
    let header = getDateString(timestamp);
    if (isRecent(timestamp)) header = "Just now";
    let entryGroup = dateMap[header];
    dateMap[header] = entryGroup ? [ ...entryGroup, e] : [e];
    return dateMap;
  }, {});
}

export const getSortedGroups = createSelector(
  [getVisibleEntries, tagDateMap, sortedByTags, readFilter],
  (entries, tagDateMap, sortedByTags, readFilter) => {
    const sortDate = readFilter === 'read' ? 'dateRead' : 'dateAdded';
    const sortedEntries = _.orderBy(entries, [sortDate], ['desc']);
    return sortedByTags
        ? getTagGroupings(sortedEntries, tagDateMap)
        : getDateGroupings(sortedEntries, sortDate)
  }
)

export const getTagsSelected = createSelector(
  // Tags updated is used in order to keep the order of the tags when
  // they are deleted or added
  [entriesSelected, entries, tagsUpdated],
  (entriesSelected, entries, tagsUpdated) => {
    if (!entriesSelected || entriesSelected.length === 0) return [];
    const firstEntryTags = entries[entriesSelected[0]].tags;
    const initialTags = tagsUpdated.length > 0 ? tagsUpdated : firstEntryTags;
    return _.reduce(entriesSelected, (tagsSelected, id) => {
      const tags = entries[id].tags
      return _.intersection(tagsSelected, tags);
    }, initialTags)
  }
)



// WEBPACK FOOTER //
// ./src/scenes/Main/selectors.js